/**
 * Cookie banner and Your privacy choices copy, Counsel G3 2026-10-22 section 2,
 * word for word (Matt approved 2026-10-23). Change only with a new Counsel memo
 * and a CONSENT_PURPOSES_VERSION bump when purposes or partners change.
 */

/** Version A: US (rr_cr=0). Notice with an opt-out. */
export const BANNER_US = {
  heading: 'We use cookies to improve this site',
  body: 'We use Google Analytics and Microsoft Clarity to learn how people use our pages. Clarity records clicks, scrolling and taps so we can see where a page is hard to use. Form fields are masked. Ad cookies from Meta and Google stay off unless you turn them on.',
  second: 'You can turn analytics off now or anytime from Your privacy choices at the bottom of every page.',
  accept: 'Got it',
  decline: 'Turn off analytics',
  choices: 'Choices',
} as const

/** Version B: EEA, UK, Switzerland and unknown region (rr_cr=1 or missing). Opt-in. */
export const BANNER_RESTRICTED = {
  heading: 'Your cookie choices',
  body: 'With your OK, we use Google Analytics and Microsoft Clarity to learn how people use our pages. Clarity records clicks, scrolling and taps so we can see where a page is hard to use. Form fields are masked. Ad cookies from Meta and Google stay off unless you turn them on.',
  second: 'You can change your mind anytime from Your privacy choices at the bottom of every page.',
  accept: 'Accept analytics',
  decline: 'Decline',
  choices: 'Choices',
} as const

export const CHOICES_PANEL = {
  title: 'Your privacy choices',
  neededTitle: 'Needed to run the site',
  neededState: 'Always on',
  neededBody: 'These keep you signed in and remember your cookie choices.',
  analyticsTitle: 'Analytics',
  analyticsBody:
    'Google Analytics and Microsoft Clarity help us see which pages work and which do not. Clarity records clicks, scrolling and taps. Form fields are masked.',
  adsTitle: 'Ads',
  adsBody: 'Lets Meta and Google use cookies to show you Ryan Realty ads about homes you may like, here and on other sites.',
  save: 'Save choices',
  /** "Privacy and cookies page" is the link. */
  readMoreBefore: 'Read more on our ',
  readMoreLink: 'Privacy and cookies page',
  readMoreAfter: '.',
} as const

export const GPC_LINE = 'Your browser is sending a Global Privacy Control signal, so ads and analytics stay off unless you change them here.'
